import React from 'react';
import { useClinicalReports } from '../../clinical-reports/ClinicalReportsContext';
import ReportSectionHead from '../../head-doctor/reports/ReportSectionHead';
import { NursingTestReportSection } from '../../head-doctor/reports/nursingReportSections';

export default function MajorReportsTestsPage() {
  const { data, summary, loading, copy: COPY, hasActiveAdvancedFilters, clearAdvancedFilters } =
    useClinicalReports();

  return (
    <>
      <ReportSectionHead
        badge={COPY.SUB_TESTS}
        title={COPY.PAGE_TESTS_TITLE}
        description={COPY.PAGE_TESTS_DESC}
      />

      <NursingTestReportSection
        data={data}
        summary={summary}
        loading={loading}
        copy={COPY}
        emptyHint={COPY.EMPTY_FILTERED_HINT}
        clearFiltersLabel={COPY.EMPTY_CLEAR_FILTERS}
        onClearFilters={hasActiveAdvancedFilters ? clearAdvancedFilters : null}
      />
    </>
  );
}
